import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Repairshop/UserRepairShops', method: 'GET', token: token })
}
